<template>
  <div>
    <list
      ref="list"
      unit="其他出库单"
      row-key="Id"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.list"
      @row-select="x=>$emit('change', x)"
      @reset-query="$emit('reset-select')"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="单据编号">
          <el-input size="mini" clearable v-model="params.DocNo" placeholder="请输入单据编号" />
        </el-form-item>
        <el-form-item label="单据日期">
          <el-date-picker
            size="mini"
            v-model.trim="params.DocDateStart"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
          <span style="margin:0 10px;">-</span>
          <el-date-picker
            size="mini"
            v-model.trim="params.DocDateEnd"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="仓库">
          <el-select
                size="mini"
                v-model="params.WarehouseId"
                placeholder="请选择"
              >
              <el-option v-for="item in wareList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"></el-option>
              </el-select>
        </el-form-item>
        <!-- <el-form-item label="商品名称">
          <el-input size="mini" clearable v-model="params.GoodsNames" placeholder="请输入商品名称" />
        </el-form-item> -->
        <el-form-item label="单据状态">
          <el-select size="mini" v-model="params.Status" placeholder="请选择" clearable>
            <el-option label="草稿" :value="0"></el-option>
            <el-option label="未生效" :value="1"></el-option>
            <el-option label="已生效" :value="2"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="DocNo" label="单据编号" min-width="110px" />
        <el-table-column prop="DocDate" label="单据日期" min-width="110px">
          <template slot-scope="{row}">
            {{row.DocDate.split(" ")[0]}}
          </template>
        </el-table-column>
        <el-table-column prop="WarehouseName" label="仓库" />
        <el-table-column prop="GoodsNames" label="商品种类" />
        <el-table-column prop="Status" label="单据状态" width="100px" align="center">
          <template slot-scope="{row}">
            <el-tag size="mini" v-if="row.Status==1" type="danger">未生效</el-tag>
            <el-tag size="mini" v-else-if="row.Status==2" type="success">已生效</el-tag>
            <el-tag size="mini" v-else type="primary">草稿</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="Remark" label="备注" min-width="100px"/>
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/stock/outDoc").default,
      wareApi: require("@/api/ba/warehouse").default,
      activeName: 0,
      wareList: [],
      params: {
        DocNo: "",
        DocDate: "",
        DocType: 0,
        WarehouseName: "",
        WarehouseId: null,
        Status: null,
        GoodsNames: "",
        DocDateStart:this.$commonJs.getDayOffset(-30),
        DocDateEnd:this.$commonJs.getDayOffset(0)
      },
    };
  },
  mounted() {
    this.wareApi.list({ PageIndex: 1, PageSize: 100 }).then(res => {
      this.wareList = res.Data
      sessionStorage.setItem("ware",JSON.stringify(res.Data))
    })
  },
  methods: {
    getPrintData(){
      let {DocNo, DocDate, WarehouseName, Status, DocDateStart, DocDateEnd} = this.params
      DocDate = DocDateStart +'-' + DocDateEnd
      let formData = [
        {
          key: 'DocNo',
          label: '单据编号',
          value: DocNo
        },
         {
          key: 'DocDate',
          label: '单据日期',
          value: DocDate
        },
        {
          key: 'WarehouseName',
          label: '仓库',
          value: WarehouseName
        },
        {
          key: 'Status',
          label: '单据状态',
          value: Status
        },
      ];
      
      return formData
    },
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.exportV2(this.params).then(() => {
        loading.close();
      });
    },
  },
};
</script>